import { useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import { appToast } from '../../../components/AppToast'
import AppFormFooterBar from '../../../components/AppFormFooterBar'
import { useTestGroupEntryScreen } from './hooks/useTestGroupEntryScreen'

export default function TestGroupEntryScreen() {
  const navigate = useNavigate()
  const { state, actions } = useTestGroupEntryScreen()

  useEffect(() => {
    if (state.error) {
      appToast.error(state.error)
    }
  }, [state.error])

  const handleBack = () => {
    navigate('/education/tests/groups')
  }

  return (
    <div className="mx-auto flex w-full max-w-[800px] flex-col gap-6 pb-24">
      {/* ── Header ── */}
      <section className="flex flex-col gap-4 border-b border-outline-variant/10 pb-5">
        <div className="flex items-center gap-3">
          <button
            type="button"
            onClick={handleBack}
            className="inline-flex h-9 w-9 items-center justify-center rounded-xl border border-outline-variant/30 bg-surface-container-lowest text-on-surface hover:bg-surface-container-high transition-colors cursor-pointer"
            title="Back to Test Groups"
          >
            <span className="material-symbols-outlined text-xl">arrow_back</span>
          </button>
          <div>
            <h1 className="font-display text-2xl font-extrabold tracking-tight text-on-surface">
              {state.groupId ? 'Edit Test Group' : 'Add New Test Group'}
            </h1>
            <p className="text-xs text-on-surface-variant">
              {state.groupId ? 'Modify exam series title and status.' : 'Define a new series or category to bundle related tests.'}
            </p>
          </div>
        </div>
      </section>

      {/* ── Main Form Card ── */}
      <section className="rounded-3xl border border-outline-variant/25 bg-surface-container-lowest p-8 shadow-sm">
        {state.isLoading ? (
          <div className="py-12 text-center text-sm text-on-surface-variant font-medium">
            Loading group details...
          </div>
        ) : (
          <form className="space-y-6" onSubmit={(e) => { e.preventDefault(); actions.handleSave(); }}>
            <div className="flex flex-col gap-2">
              <label className="text-xs font-bold uppercase tracking-wider text-on-surface-variant">
                Test Group Name <span className="text-error">*</span>
              </label>
              <input
                type="text"
                name="name"
                value={state.formData.name || ''}
                onChange={actions.handleChange}
                placeholder="e.g. Unit Tests, Prelims, Weekly Revision"
                required
                className="w-full rounded-xl border border-outline-variant/30 bg-surface-container-low px-4 py-3 text-sm text-on-surface placeholder:text-on-surface-variant/40 focus:border-primary focus:bg-surface-container-lowest focus:outline-none transition-all"
              />
            </div>

            {state.error && (
              <div className="rounded-xl border border-error/30 bg-error-container p-4 text-xs font-medium text-error">
                {state.error}
              </div>
            )}
          </form>
        )}
      </section>

      {/* ── Shared Standard Form Footer ── */}
      <AppFormFooterBar
        cancelPath="/education/tests/groups"
        onSaveExit={actions.handleSave}
        saveLabel={state.groupId ? 'Save Changes' : 'Create Group'}
        isSaving={state.isSaving}
      />
    </div>
  )
}
